var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,4.9C15.2,1,8.8,1,4.9,4.9c-2.9,2.9-3.8,7.3-2.1,11c0.1,0.2,0.1,0.4,0.1,0.6L2,20.8 c-0.1,0.3,0,0.7,0.3,0.9C2.5,21.9,2.7,22,3,22h0.2l4.3-0.9c0.2,0,0.4,0,0.6,0.1c5.1,2.2,11-0.2,13.1-5.2 C22.9,12.2,22,7.8,19.1,4.9L19.1,4.9z M19.9,13.3c-0.7,4.4-4.8,7.3-9.2,6.6c-0.6-0.1-1.2-0.3-1.8-0.5c-0.4-0.2-0.8-0.3-1.2-0.3 c-0.2,0-0.4,0-0.6,0l-2.8,0.6l0.6-2.8c0.1-0.6,0-1.2-0.2-1.8C2.9,11,4.8,6.3,8.9,4.6c0.6-0.2,1.2-0.4,1.8-0.5 c4.4-0.7,8.5,2.2,9.2,6.6C20,11.6,20,12.4,19.9,13.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.852f06f4fac7e965d28d3d588b40ea8d.svg";
export { ForwardRef as ReactComponent };